const getSubdomain = () => {
  const array = window.location.host.split(".");
  if (array[0] === "www") {
    return array[1];
  }
  return array[0];
};

export default getSubdomain;
